export enum FeatureToggleEnum {
    USE_V7_THEME = 'ft_v7_theme',
    USE_NEW_CALENDAR = 'ft_new_calendar',
    USE_AUTOCOMPLETE_ES_VERSION = 'ft_autocomplete_es_version',
    USE_HOME_PAGE_ES_VERSION = 'ft_home_page_es_version',
    USE_SEO_FRIENDLY_NAVIGATION = 'ft_seo_friendly_navigation',
    USE_TOTAL_PRICE = 'ft_total_price',
    USE_SHORT_JOURNEY = 'ft_short_journey',
}
